// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"589":"2cd2d6ca","787":"69e70e80"}[chunkId] + ".chunk.js";
};